import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	Input,
	OnChanges,
	SimpleChanges
} from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { CookieService } from 'ngx-cookie-service';
import { MessageNotification } from 'src/app/shared/models/message-notification';
import { Conversation } from 'src/app/shared/models/messaging/conversation';

@Component({
	selector: 'app-list-user-messaging',
	templateUrl: './list-user-messaging.component.html',
	styleUrls: ['./list-user-messaging.component.scss']
})
export class ListUserMessagingComponent implements OnChanges {
	@Input() currentUser: User;
	@Input() conversation: Conversation[] = [];
	@Input() notifications: MessageNotification[] = [];
	@Output() newConvEvent = new EventEmitter();
	@Output() receiverEmitter = new EventEmitter<User>();
	@Output() openConversation = new EventEmitter();

	userList: User[];
	searchedName = '';
	newConv: boolean;

	constructor() {}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			changes.conversation.previousValue?.length !==
			changes.conversation.currentValue.length
		) {
			this.userList = changes.conversation.currentValue.map(
				(conversation) => conversation.user
			);
		}
	}

	newConversation() {
		this.newConvEvent.emit(true);
	}

	emitReceiver(userReceiver: User) {
		this.receiverEmitter.emit(userReceiver);
		this.openConversation.emit(true);
	}

	getNotificationNumberByIdSender(idSender): number {
		const notif = this.notifications.find((notification) => {
			return notification.idSender === idSender;
		});

		return notif ? notif.messagesNumber : 0;
	}
}
